import { Injectable } from '@nestjs/common';
import { PalletCapacity } from './pallet-capacity.entity';
import { PalletCapacityAdapter } from './dto/pallet-capacity.adapter'
import { PalletCapacityRequest } from './dto/pallet-capacity.request'
import { PalletCapacityDTO } from './dto/pallet-capacity.dto';
import { PalletCapacityResponseModel, AllPalletCapacityResponseModel } from '@gtpl/shared-models/masters'
import { getManager, Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import appSettings from 'apps/services/config';
import { Pallet } from '../pallets/pallets.entity';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class PalletCapacityService {
  constructor(
    private logService:LogsService,
    @InjectRepository(PalletCapacity) private PalletCapacityRepository: Repository<PalletCapacity>,
    private PalletCapacityAdapter: PalletCapacityAdapter,
  ) { }

  async createPalletCapacity(palletCapacitysDto: PalletCapacityDTO, isUpdate: boolean, request: Request): Promise<PalletCapacityResponseModel> {
    try {
      //this section will be executed while creating a new user only
      if (!isUpdate) {
        const PalletCapacityEntity = await this.getDuplicates(palletCapacitysDto.palletCapacity, palletCapacitysDto.packingMethodId, palletCapacitysDto.sizeCategory);
        if (PalletCapacityEntity) {
          throw new PalletCapacityResponseModel(false,11104, 'Pallet Capacity already exists');
        }
      }
      else {
        const PalletCapacityEntity = await this.getDuplicates(palletCapacitysDto.palletCapacity, palletCapacitysDto.packingMethodId, palletCapacitysDto.sizeCategory);
        if (PalletCapacityEntity) {
          if (PalletCapacityEntity.palletCapacityId != palletCapacitysDto.palletCapacityId) {
            throw new PalletCapacityResponseModel(false,11104, 'Pallet Capacity already exists');
          }
        }
      }
      const PalletCapacityEntity: PalletCapacity = this.PalletCapacityAdapter.convertDtoToEntity(palletCapacitysDto, isUpdate);
      const savedPalletCapacitysEntity: PalletCapacity = await this.PalletCapacityRepository.save(PalletCapacityEntity);
      const palletCapacityDto: PalletCapacityDTO = this.PalletCapacityAdapter.convertEntityToDto(savedPalletCapacitysEntity);

      if (palletCapacityDto) {
        const response = new PalletCapacityResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'Pallet Capacity Updated Successfully' : 'Pallet Capacity Created Successfully', palletCapacityDto);
        const name=isUpdate?'updated':'created'
        const newLogDto = new LogsDto(1,name, 'PalletCapacity', palletCapacityDto.palletCapacityId, true, '',palletCapacityDto.createdUser)
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        return response;
      } else {
        throw new PalletCapacityResponseModel(false,11106, 'Pallet Capacity saved but issue while transforming into DTO');
      }
    }
    catch (error) {
      return error;
    }
  }

  /**
* gets all  Pallet Capacitys details  
* @returns all the Pallet Capacity details .
*/
  // @LogActions({ isAsync: true })
  async getAll(): Promise<AllPalletCapacityResponseModel> {
    try {
      const palletCapacitysDtos: PalletCapacityDTO[] = [];
      // retrieves all plants
      const palletCapacityEntities: PalletCapacity[] = await this.PalletCapacityRepository.find({ order: { 'palletCapacity': "ASC" } });
      console.log(palletCapacityEntities);
      if (palletCapacityEntities.length > 0) {
        palletCapacityEntities.forEach(palletCapacityEntity => {
          const convertedpalletCapacityDto: PalletCapacityDTO = this.PalletCapacityAdapter.convertEntityToDto(palletCapacityEntity);
          palletCapacitysDtos.push(convertedpalletCapacityDto);
        });
        const response = new AllPalletCapacityResponseModel(true, 11208, "Pallet Capacitys retrieved successfully", palletCapacitysDtos);
        return response;
      } else {
        //   console.log('yest')
        throw new PalletCapacityResponseModel(false,99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }



  /**
* It deactivates Pallet Capacity 
* @param palletCapacityRequest Pallet Capacity  as string
* @returns true or false
*/
  // @LogActions({isAsync: true})
  async activateOrDeactivatePalletCapacity(productReq: PalletCapacityRequest): Promise<PalletCapacityResponseModel> {
    try {
      const palletCapacityExists = await this.getpalletCapacityById(productReq.palletCapacityId);
      if (palletCapacityExists) {
        if (productReq.versionFlag !== palletCapacityExists.versionFlag) {
          throw new PalletCapacityResponseModel(false,10113, 'Someone updated the current Pallet Capacity information.Refresh and try again');
        } else {

          const palletCapacitySatatus = await this.PalletCapacityRepository.update(
            { palletCapacityId: productReq.palletCapacityId },
            { isActive: productReq.isActive, updatedUser: productReq.updatedUser });

          if (palletCapacityExists.isActive) {
            if (palletCapacitySatatus.affected) {
              const palletCapacityResponse: PalletCapacityResponseModel = new PalletCapacityResponseModel(true, 10115, 'Pallet Capacity is de-activated successfully');
              return palletCapacityResponse;
            } else {
              throw new PalletCapacityResponseModel(false,10111, 'Pallet Capacity is already deactivated');
            }
          } else {
            if (palletCapacitySatatus.affected) {
              const palletCapacityResponse: PalletCapacityResponseModel = new PalletCapacityResponseModel(true, 10114, 'Pallet Capacity is activated successfully');
              return palletCapacityResponse;
            } else {
              throw new PalletCapacityResponseModel(false,10112, 'Pallet Capacity is already  activated');
            }
          }
          // }
        }
      } else {
        throw new PalletCapacityResponseModel(false,99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }

  async getDuplicates(palletCapacity: number, packStyle: number, sizeCategory: string): Promise<PalletCapacity> {
    //  console.log(employeeId);
    const response = await this.PalletCapacityRepository.findOne({
      where: { palletCapacity: palletCapacity, packingMethodId: packStyle, sizeCategory: sizeCategory },
    });
    // console.log(response);
    if (response) {
      return response;
    } else {
      return null;
    }
  }

  async getpalletCapacityById(palletCapacityId: number): Promise<PalletCapacity> {
    //  console.log(employeeId);
    const response = await this.PalletCapacityRepository.findOne({
      where: { palletCapacityId: palletCapacityId },
    });
    // console.log(response);
    if (response) {
      return response;
    } else {
      return null;
    }
  }

  // async getAllPalletCapacitys():Promise<AllPalletCapacityResponseModel>{
  //   try{
  //       const manager = getManager();
  //       const query = `SELECT p.pallet_capacity_id as palletCapacityId,p.pallet_capacity as palletCapacity,p.size_category as sizeCategory,pm.packing_method_name as packMethod,u.unit_name as unitName,p.is_active as isActive,p.version_flag as versionFlag FROM ` + appSettings.masters_db + `.pallet_capacity p
  //        LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = p.packing_method_id
  //        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = p.unit_id
  //        ORDER BY pallet_capacity_id ASC`
  //        const entities : PalletCapacity[] = await manager.query(query)
  //        if(entities){
  //                 const response = new AllPalletCapacityResponseModel(true, 1, 'Data retrieved successfully', entities);
  //                 return response;
  //             } else {
  //                 throw new PalletCapacityResponseModel(false,99998, 'Data Not Found');
  //             }
  //         } catch (err) {
  //             console.log(err)
  //             return err;
  //         }
  //       }

  async getAllPalletCapacitys(): Promise<AllPalletCapacityResponseModel> {
    try {
      const palletCapacityDTO: PalletCapacityDTO[] = [];
      const palletCapacityEntities: PalletCapacity[] = await this.PalletCapacityRepository.find({
        order: { palletCapacity: "ASC" },relations:['packingMethodInfo','unitCodeInfo']
      });
      if (palletCapacityEntities.length > 0) {
        palletCapacityEntities.forEach(palletCapacityEntity => {
          const convertedpalletCapacityDTO: PalletCapacityDTO = this.PalletCapacityAdapter.convertEntityToDto(palletCapacityEntity);
          palletCapacityDTO.push(convertedpalletCapacityDTO);
        });
        const response = new AllPalletCapacityResponseModel(true, 11208, 'Pallet Capacity Retrived Succesfully', palletCapacityDTO);
        const newLogDto = new LogsDto(1,'view', 'PalletCapacity', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response;
      } else {
        throw new PalletCapacityResponseModel(false,99998, 'No Data Found');
      }
    } catch (err) {
      return err;
    }
  }
}
